module.exports = __webpack_public_path__ + "img/honely-bg1.3f00543f.jpg";